import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Trophy, Crown } from "lucide-react";
import VipBadge from "@/components/app/VipBadge";

export default function Leaderboard() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/leaderboard").then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-10">
      <div className="mb-10 flex items-end justify-between flex-wrap gap-4">
        <div>
          <span className="tape-label">GLOBAL LADDER</span>
          <h1 className="font-display text-5xl md:text-7xl mt-3 leading-none">
            THE<br /><span className="text-[var(--primary)]">TOP MOGS.</span>
          </h1>
        </div>
        <Trophy className="w-12 h-12 text-[var(--primary)]" />
      </div>

      <div className="panel">
        <div className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-[var(--border)] text-[10px] font-mono uppercase tracking-widest text-[var(--text-muted)]">
          <div className="col-span-1">RANK</div>
          <div className="col-span-5">USER</div>
          <div className="col-span-2 text-right">ELO</div>
          <div className="col-span-2 text-right">W / L</div>
          <div className="col-span-2 text-right">BEST</div>
        </div>
        {loading && <div className="p-10 text-center text-xs font-mono text-[var(--text-muted)]">LOADING...</div>}
        <div className="divide-y divide-[var(--border)]">
          {rows.map((u, i) => {
            const isMe = user && u.id === user.id;
            return (
              <div
                key={u.id}
                className={`grid grid-cols-12 gap-4 px-6 py-4 items-center transition-colors ${isMe ? "bg-[var(--primary)]/10" : "hover:bg-[var(--surface)]"}`}
                data-testid={`leaderboard-row-${i}`}
              >
                <div className="col-span-1 font-display text-2xl">
                  {i === 0 ? (
                    <span className="flex items-center gap-1 text-[var(--primary)]"><Crown className="w-5 h-5" />1</span>
                  ) : (
                    <span className={i < 3 ? "text-white" : "text-[var(--text-muted)]"}>{i + 1}</span>
                  )}
                </div>
                <div className="col-span-5">
                  <div className="font-mono text-white flex items-center gap-2 flex-wrap">
                    @{u.username}
                    <VipBadge user={u} size="sm" />
                    {isMe && <span className="text-[10px] text-[var(--primary)] ml-1">(YOU)</span>}
                  </div>
                </div>
                <div className="col-span-2 text-right font-display text-2xl text-white">{u.elo}</div>
                <div className="col-span-2 text-right font-mono text-xs text-[var(--text-muted)]">{u.wins}/{u.losses}</div>
                <div className="col-span-2 text-right font-display text-2xl text-[var(--primary)]">{u.best_score}</div>
              </div>
            );
          })}
          {!loading && rows.length === 0 && (
            <div className="p-10 text-center text-xs font-mono text-[var(--text-muted)]">No one on the ladder yet. Be first.</div>
          )}
        </div>
      </div>
    </div>
  );
}
